"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _reusableFields = require("egov-ui-kit/config/forms/specs/PropertyTaxPayMutation/utils/reusableFields");

var _actions = require("egov-ui-kit/redux/form/actions");

var _utils = require("egov-ui-framework/ui-config/screens/specs/utils");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "mailingAddress",
  fields: (0, _extends3.default)({
    holdingAddress: {
      id: "holdingAddress",
      jsonPath: "Properties[0].mailingAddress.holdingAddress",
      type: "textfield",
      floatingLabelText: "Holding Address",
      required: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5, color: "red" },
      pattern: (0, _utils.getPattern)("Address"),
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "holdingAddress", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.holdingAddress", field.value));
      }
    }
  }, _reusableFields.street, {
    additionalAddress: {
      id: "holdingAddress",
      jsonPath: "Properties[0].mailingAddress.additionalAddress",
      type: "textfield",
      floatingLabelText: "Holding Address",
      required: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5, color: "red" },
      pattern: (0, _utils.getPattern)("Address"),
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "additionalAddress", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.additionalAddress", field.value));
      }
    },
    pincode: {
      id: "pincode",
      jsonPath: "Properties[0].mailingAddress.pincode",
      type: "textfield",
      floatingLabelText: "Pincode",
      required: true,
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5, color: "red" },
      pattern: (0, _utils.getPattern)("pincode"),
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "pincode", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.pincode", field.value));
      }
    },
    mobileNumber: {
      id: "mobileNumber",
      jsonPath: "Properties[0].mailingAddress.mobileNumber",
      type: "textfield",
      floatingLabelText: "Mobile No.",
      pattern: (0, _utils.getPattern)("MobileNo"),
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "mobileNumber", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.mobileNumber", field.value));
      }
    },
    alterMobileNumber: {
      id: "alterMobileNumber",
      jsonPath: "Properties[0].mailingAddress.alterMobileNumber",
      type: "textfield",
      floatingLabelText: "Alternative Mobile No.",
      pattern: (0, _utils.getPattern)("MobileNo"),
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "alterMobileNumber", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.alterMobileNumber", field.value));
      }
    },
    ownerEmail: {
      id: "ownerEmail",
      jsonPath: "Properties[0].mailingAddress.emailId",
      type: "textfield",
      floatingLabelText: "Email ID",
      errorMessage: "Invalid Email!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      pattern: (0, _utils.getPattern)("Email"),
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "ownerEmail", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.emailId", field.value));
      }
    }
  }),
  beforeInitForm: function beforeInitForm(action, store, dispatch) {
    try {
      var state = store.getState();
      var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties");
      dispatch((0, _actions.setFieldProperty)("propertyAddress", "street", "disable", true));
      if (data && data.length > 0) {
        var mailingAddress = data[0].mailingAddress;
        dispatch((0, _actions.setFieldProperty)("mailingAddress", "pincode", "value", mailingAddress.pincode || ""));
        dispatch((0, _actions.setFieldProperty)("mailingAddress", "ownerEmail", "value", mailingAddress.emailId || ""));
        dispatch((0, _actions.setFieldProperty)("mailingAddress", "mobileNumber", "value", mailingAddress.mobileNumber || ""));
        dispatch((0, _actions.setFieldProperty)("mailingAddress", "alterMobileNumber", "value", mailingAddress.alterMobileNumber || ""));
        dispatch((0, _actions.setFieldProperty)("mailingAddress", "policeStation", "value", mailingAddress.policeStation || ""));
        dispatch((0, _actions.setFieldProperty)("mailingAddress", "holdingAddress", "value", mailingAddress.holdingAddress || ""));

        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.emailId", mailingAddress.emailId || ""));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.pincode", mailingAddress.pincode || ""));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.holdingAddress", mailingAddress.holdingAddress || ""));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.mobileNumber", mailingAddress.mobileNumber || ""));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.alterMobileNumber", mailingAddress.alterMobileNumber || ""));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].mailingAddress.policeStation", mailingAddress.policeStation || ""));
      }

      return action;
    } catch (e) {
      console.log(e);
      return action;
    }
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};
exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/mailingAddress.js
// module id = 1882
// module chunks = 1137